import { ReportRequest } from '@/client/reports';
import { OverdueUsers } from '@/components/dashboards/admin/OverdueUsers';
import { DepartmentOverdueChart } from '@/ui/charts/bar-chart';
import { FlexContainer } from '@/ui/styled-ui';
import React from 'react';
import styled from 'styled-components';

const StyledContainer = styled(FlexContainer)`
  flex-wrap: wrap;

  > div {
    flex: 1 1 400px;
    min-width: 0;
    max-width: 100%;
  }
`;

type AwarenessAnalysisProps = {
  filters: ReportRequest;
};

export const AwarenessAnalysis = ({ filters }: AwarenessAnalysisProps) => {
  return (
    <StyledContainer
      align="stretch"
      justify="space-between"
      gap="var(--small-padding)"
      className="mt-4"
      id="awareness-analysis-container"
    >
      <OverdueUsers filters={filters} />
      <DepartmentOverdueChart filters={filters} />
    </StyledContainer>
  );
};
